module.exports = __webpack_public_path__ + "static/media/Unmasked.d4f7beac.jpeg";